import { render } from "./noproject.vue?vue&type=template&id=9be70dbc&scoped=true"
import script from "./noproject.vue?vue&type=script&lang=js"
export * from "./noproject.vue?vue&type=script&lang=js"

import "./noproject.vue?vue&type=style&index=0&id=9be70dbc&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9be70dbc"]])

export default __exports__